import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDrawerRef, NzMessageService } from 'ng-zorro-antd';
import { Employee } from '@app/_models/_DTOs/employee';
import { Department } from '@app/_models/_DTOs/department';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetType } from '@app/_models/enums/assetType';
import { EmployeeService } from '@app/_services/employee.service';
import { AssetService, AuthenticationService } from '@app/_services';
import { LocationService } from '@app/_services/location.service';
import { DepartmentService } from '@app/_services/department.service';
import { SupplierService } from '@app/_services/supplier.service';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { Location } from '@app/_models/_DTOs/location';
import { ITuple } from '@app/_models/tuple';
import { AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { Subject } from 'rxjs';
import { EmployeeViewModel } from '@app/_models/_viewModels/employee.viewmodel';
import { UserService } from '@app/_services/user.service';
import { User } from '@app/_models/_DTOs/user';
import { UserViewModel } from '@app/_models/_viewModels/user.viewmodel';
import { LegalEntity } from '@app/_models/_DTOs/legalEntity';
import { LegalEntityService } from '@app/_services/legalEntity.service';
import { BaseComponent } from '@app/_shared/base.component';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { UserToken } from '@app/_models';
import { ResizeService } from '@app/_services/resize.service';

@Component({
  selector: "app-user-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.css"],
})
export class UserListComponent extends BaseComponent implements OnInit {
  onScreenResize(screenSize: SCREEN_SIZE) {}
  onUserAvailable(userToken: UserToken) {}
  level: number = 0;

  pageIndex = 1;
  pageSize = 10;
  total = 1;
  userList: User[] = [];
  loading = true;

  editDrawerVisible: boolean = false;
  isSavingUser: boolean = false;
  isEditing: boolean = false;

  errorMessages = {};

  userViewModel: UserViewModel = null;
  legalEntities: LegalEntity[] = [];

  constructor(
    private userService: UserService,
    private assetService: AssetService,
    private locationService: LocationService,
    private departmentService: DepartmentService,
    private legalEntityService: LegalEntityService,
    private messageService: NzMessageService,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService
  ) {
    super(authenticationService, resizeService);
    this.initModel();
  }

  ngOnInit() {
    this.searchData();
    this.loadDataForDropdowns();
  }

  loadDataForDropdowns() {
    this.legalEntityService.getAllBasic().subscribe((data: LegalEntity[]) => {
      this.legalEntities = data;
    });
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loading = true;
    this.userService
      .getPage(this.pageIndex, this.pageSize, "LastName")
      .subscribe((data: ITuple<User>) => {
        this.loading = false;
        this.total = data.item2;
        this.userList = data.item1;
      });
  }

  initModel(user?: User) {
    if (user) {
      this.userViewModel = {
        id: user.id != undefined ? user.id : -1,
        firstName: user.firstName ? user.firstName : "",
        lastName: user.lastName ? user.lastName : "",
        userIdentityId: user.identityId ? user.identityId : "",
        userName: user.username ? user.username : "",
        role: user.roles && user.roles.length > 0 ? user.roles[0] : "",
        legalEntityIds: user.legalEntityIds ? user.legalEntityIds : [],
        password: "",
      };
    } else {
      this.userViewModel = {
        id: -1,
        firstName: "",
        lastName: "",
        userIdentityId: "",
        userName: "",
        role: "",
        legalEntityIds: [],
        password: undefined,
      };
    }
  }

  saveUser(form: NgForm) {
    this.isSavingUser = true;
    if (this.isEditing) {
      this.userService
        .put<UserViewModel>(this.userViewModel, this.userViewModel.id)
        .subscribe(
          (result) => {
            this.messageService.create(
              "success",
              "Korisnik uspješno izmijenjen",
              {
                nzDuration: 3000,
              }
            );
            this.isSavingUser = false;
            this.searchData();
            form.reset();
            this.closeEditDrawer();
          },
          (error) => {
            if (error.ParamName) {
              if (form.controls[error.ParamName]) {
                form.controls[error.ParamName].setErrors({ custom: true });
                var errorMessage = error.Message.split("Parameter name")[0];
                this.errorMessages[error.ParamName] = errorMessage;
              }
            }
            this.isSavingUser = false;
          }
        );
    } else {
      this.userService.post<UserViewModel>(this.userViewModel).subscribe(
        (result) => {
          this.messageService.create("success", "Korisnik uspješno dodan");
          this.isSavingUser = false;
          this.searchData();
          form.reset();
          this.closeEditDrawer();
        },
        (error) => {
          if (error.ParamName) {
            if (form.controls[error.ParamName]) {
              form.controls[error.ParamName].setErrors({ custom: true });
              var errorMessage = error.Message.split("Parameter name")[0];
              this.errorMessages[error.ParamName] = errorMessage;
            }
          }
          this.isSavingUser = false;
        }
      );
    }
  }

  editUser(user: User) {
    this.initModel(user);
    this.isEditing = true;
    this.openEditDrawer();
  }

  deleteUser(user: User) {
    this.userService.deleteUser(user.identityId).subscribe(
      (result) => {
        this.messageService.create("success", "Korisnik uspješno deaktiviran");
        this.searchData();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  openEditDrawer() {
    this.editDrawerVisible = true;
  }

  closeEditDrawer(form?: NgForm) {
    this.isEditing = false;
    this.editDrawerVisible = false;
    if (form) {
      form.reset();
    }
    this.initModel();
  }
}
